function filterLinksWithAnchor(link) {

    const href = link.getAttribute('href')

    if (!href) {
        return false;
    }

    return href.indexOf('#') > -1;
}

function handleLinkClick(link) {

    const anchor = link.getAttribute('href').split('#')[1]

    const section = document.getElementById(anchor)

    if(!section) {
        console.warn(`The section #${anchor} does not exist.`)
        return
    }

    section.scrollIntoView({
        behavior: 'smooth',
    })
}

function bindLinkEvents(link) {
    link.addEventListener('click', (e) => {
        e.preventDefault()
        handleLinkClick(link)
    })
}

export function main() {

    const links = Array.from(document.querySelectorAll('a'))

    const linksWithAnchor = links.filter(filterLinksWithAnchor)

    linksWithAnchor.forEach(bindLinkEvents)
}
